if (!window.__productCardSwatchInit) {
  window.__productCardSwatchInit = true;
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.m-product-card__swatch-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.m-product-card');
    if (!card) return;

    var imageUrl = btn.getAttribute('data-variant-image');
    var srcset = btn.getAttribute('data-variant-srcset');
    if (!imageUrl) return;

    var swatches = card.querySelectorAll('.m-product-card__swatch-btn');
    swatches.forEach(function(s) { s.classList.remove('is-active'); });
    btn.classList.add('is-active');

    var img = card.querySelector('.m-product-card__image img');
    if (img) {
      img.src = imageUrl;
      if (srcset) img.srcset = srcset;
    }
  });
}
